export default __webpack_public_path__ + "1.17.19/static/media/libreView-ar.3cf809db.svg";